<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For my cousin Adrienne, whose love and support means so much to me</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4a6f1f9a